import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import { withRouter, Link } from 'react-router-dom';
import qs from 'query-string';
import { IconButton, Grid } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Box from '@material-ui/core/Box';
import * as actions from 'actions';
import * as bookingsSelectors from 'selectors/bookings';
import ActionFooter from 'components/BookingInfo/ActionFooter/index';
import BookingInfo from 'components/BookingInfo/index';
import CircularProgress from 'components/shared/CircularProgress';
import Errors from 'components/shared/Errors';
import Main from 'components/templates/Main';
import Success from 'components/shared/Success';
import TransactionStatus from 'components/shared/TransactionStatus';
import MangoImage from 'assets/img/powered-by-mangopay.png';
import PaymethodsImage from 'assets/img/paymethods.png';

class BookingInfoContainer extends React.Component {
  constructor() {
    super();

    this.state = {
      disableButtons: false,
    };
  }

  static getDerivedStateFromProps(props) {
    if (props.booking.cancelled_at) {
      return { disableButtons: false };
    }

    return null;
  }

  componentDidMount() {
    const { bookingId } = this.props.match.params;
    this.props.fetchBookingRequest({ bookingId });
  }

  onAccept = (
    payment_method,
    card,
    klarna_addressline1,
    klarna_city,
    klarna_postalcode,
  ) => {
    this.setState({ disableButtons: true });
    const { bookingId } = this.props.match.params;
    this.props.bookingActionRequest({
      bookingId,
      action: 'payment',
      payment_method,
      card,
      klarna_addressline1,
      klarna_city,
      klarna_postalcode,
    });
  }

  onCancel = (values) => {
    this.setState({ disableButtons: true });

    const { bookingId } = this.props.match.params;
    const { cancellation_reason } = values;
    this.props.bookingActionRequest({ bookingId, action: 'cancel', cancellation_reason });
  }

  render() {
    const {
      booking,
      cancellationPolicy,
      errors,
      isHost,
      location,
      success,
      isBookingStrict,
    } = this.props;

    const { transaction, errorCode, errorMessage } = qs.parse(location.search);

    const { conversationId } = this.props.match.params;
    const { url } = this.props.match;
    const cottage = pick(booking.cottage, ['title_sv', 'id']);

    if (booking.id && booking.cottage.images.length === 0) {
      cottage.cottagePic = 'http://via.placeholder.com/150x100';
    } else if (booking.id) {
      cottage.cottagePic = `/img/${booking.cottage.images[0].filename}?w=600&h=600`;
    }

    return (
      <Main
        title={(
          <div>
            <IconButton
              color="inherit"
              component={Link}
              to={`/conversations/${conversationId}`}
            >
              <ArrowBack />
            </IconButton>
            {booking.id && `${cottage.title_sv} #${booking.id}`}
          </div>
        )}
      >
        {
          !!transaction && !!booking && (
            <Box m={1}>
              <TransactionStatus
                booking={booking}
                status={transaction}
                errorCode={errorCode}
                errorMessage={errorMessage}
              />
            </Box>
          )
        }
        {
          !booking.id && (<CircularProgress />)
        }
        {
          !!booking.id && (
            <>
              <BookingInfo
                booking={booking}
                isHost={isHost}
                cancellationPolicy={cancellationPolicy}
                cottage={cottage}
              />
              <ActionFooter
                booking={booking}
                isHost={isHost}
                url={url}
                isBookingStrict={isBookingStrict}
                disableButtons={this.state.disableButtons}
                onCancel={this.onCancel}
                onAccept={this.onAccept}
              />
              <Grid container justifyContent="center">
                <Grid item xs={8} sm={4} md={2} lg={2}>
                  <img src={PaymethodsImage} alt="Klarna" />
                </Grid>
              </Grid>
              <Grid container justifyContent="center">
                <Grid item xs={8} sm={6} md={4} lg={4}>
                  <img src={MangoImage} alt="Mangopay" />
                </Grid>
              </Grid>
            </>
          )
        }
        <Success success={success} />
        <Errors errors={errors} />
      </Main>
    );
  }
}

BookingInfoContainer.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.number,
    cottage: PropTypes.shape({
      images: PropTypes.arrayOf(PropTypes.shape({
        filename: PropTypes.string,
      })),
    }),
    cancelled_at: PropTypes.string,
  }).isRequired,
  cancellationPolicy: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  match: PropTypes.shape({
    url: PropTypes.string,
    params: PropTypes.shape({
      bookingId: PropTypes.string.isRequired,
      conversationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
  isHost: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  success: PropTypes.shape({}),
  fetchBookingRequest: PropTypes.func.isRequired,
  isBookingStrict: PropTypes.bool,
  bookingActionRequest: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const booking = bookingsSelectors.singleBooking(state);
  let cancellationPolicy = null;
  if (!isEmpty(booking) && !isEmpty(state.bookings.cancellationPolicy)) {
    cancellationPolicy = state.bookings.cancellationPolicy
      .find((item) => (item.id === booking.cancellation_policy_id));
  }

  return {
    booking,
    cancellationPolicy,
    errors: bookingsSelectors.error(state),
    isHost: bookingsSelectors.isHost(state),
    success: bookingsSelectors.success(state),
    isBookingStrict: bookingsSelectors.isBookingStrict(state),
  };
};

const mapDispatchToProps = {
  fetchBookingRequest: actions.fetchBookingRequest,
  bookingActionRequest: actions.bookingActionRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BookingInfoContainer));
